module.exports = __webpack_public_path__ + "media/images/front/icons/organization-6c97bb32c761e1e95d77064f37563f09.png";